module.exports = __webpack_public_path__ + "img/7.1c90d3ba.png";